import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

export default {
	namespaced: true,
	state() {
		return {
			our_specialists: null,
			selected_specialist: null,
		}
	},
	mutations,
	actions,
	getters,
}
